import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { Personnel } from 'model/modal-cms/personnel';
import { AdminService } from '../../../services/admin';
declare var moment: any;
declare var mdtoast: any;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Vous n\'avez pas accès à cette donnée.', { duration: 5000, init: true, type: mdtoast.ERROR });


@Component({
  selector: 'app-rappert-activiter-aut',
  templateUrl: './rappert-activiter-aut.component.html',
  styleUrls: ['./rappert-activiter-aut.component.scss']
})
export class RappertActiviterAutComponent implements OnInit {
  id:any;
  personnel : Personnel=new Personnel(null);
  etat:any = "AUT";
  personnel_autre: any;
  id_agent_actuel:any;

constructor(public activatedRoute: ActivatedRoute,private router: Router,public adminService: AdminService, public cmsService: CMSService){ 
      this.id_agent_actuel = this.adminService.getUserIMIscrit();
  this.id = activatedRoute.snapshot.params['id']; }

  ngOnInit() {
    this.getListeAutre();
  }


  chercherRapport(rp){
    this.cmsService.getAutreParIM(rp)
      .subscribe(data => {
        console.log("data milay"+data)
        this.personnel_autre = data
      },
        err => {
          console.log(err);
        })
  }

  getListeAutre() {
    this.cmsService.getAutre(this.etat)
      .subscribe(data => {
        console.log("data milay"+data)
        this.personnel_autre = data
      },
        err => {
          console.log(err);
        })

  }

  openActivity_(id_remb:any){
    this.router.navigate(['rapport-autre-det/'+id_remb]);
  }


  openActivity(id_remb:any) {
    //322670
    let im_chef = 322670 
    //320744
    let im_daf = 320744 
    //"203 131 007 842"
    let im_li = 438282
     let im_tody = 280246 
      let im_sophie = 278440  
    if(id_remb == this.id_agent_actuel || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_daf  || this.id_agent_actuel == im_li      
       || this.id_agent_actuel == im_tody || this.id_agent_actuel == im_sophie){
        this.router.navigate(['rapport-autre-det/'+id_remb]);
    } else{
      error_message.show();  
    }  

  }
}
